import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { Sparte, TextNodeType } from '@mwe/models';
import { TranslatePipe } from '@ngx-translate/core';
import { ProductIconsComponent } from '../../product-icons/product-icons.component';

@Component({
  selector: 'mwe-clickable-products-card',
  templateUrl: './clickable-products-card.component.html',
  imports: [TranslatePipe, ProductIconsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClickableProductsCardComponent {
  readonly categories = input<Sparte[]>();
  readonly categoryTranslationKeys = input<Record<string, string>>({});
  readonly ariaTitle = input<string>();
  readonly dataTest = input<string>();
  readonly hasAutoFocus = input<boolean>(false);
  readonly disabled = input<boolean>(false);
  readonly clickable = input<boolean>(true);
  readonly textNodeType = input<TextNodeType>('h6');

  readonly cardClicked = output<void>();

  readonly cardTabIndex = computed<number>(() => (this.disabled() || !this.clickable() ? -1 : 0));
  readonly cardClass = computed<string>(
    () => `card-basic h-100 p-0 ${this.disabled() ? 'card-disabled' : this.clickable() ? 'card-clickable' : ''}`,
  );
}
